import { ref, computed, onMounted } from 'vue';
import { getMenuCategories } from '@/services/menuCategoryService';
import { createSlug } from '@/services/stringService';
import { useStore } from 'vuex';

export const useMenuCategories = () => {
    const store = useStore();

    const lunchCombos = computed(() => store.getters.getSelectedLocationlunchCombos);
    const availableLocationCategories = computed(() => store.getters.getLocationMenu.map((cat) => createSlug(cat.name)));
    const refresherKey = ref(0);

    const menuCategories = ref(<any[]>[]);

    const fetchMenuCategories = async () => {
        menuCategories.value = await getMenuCategories();
    };

    onMounted(fetchMenuCategories);

    const sortedMenuCategories = computed(() => {
        const categories = menuCategories.value
            .filter((cat: any) => !!cat.order)
            .sort((a: any, b: any) => a.order - b.order)
            .filter((cat: any) => availableLocationCategories.value.includes(cat.identifier) || (lunchCombos.value?.length > 0 && cat.identifier === 'lunch-combos'));

        const valueBundle = computed(() => store.getters.getValueBundle);

        if (valueBundle.value) {
            categories.splice(1, 0, {
                name: valueBundle.value.name,
                description: null,
                path: 'pizza-pals',
                identifier: 'pizza-pals',
                img: 'PizzaPals.jpg',
                order: '99',
                largeColumn: '1',
                use_base_url: true,
            });
        }

        return categories;
    });

    return {
        lunchCombos,
        availableLocationCategories,
        refresherKey,
        sortedMenuCategories,
    };
};
